import CraftChangeStatusBtn from "./craft-change-status-btn";

import "./craft-buttons.scss";


const CraftButtons = {
    ChangeStatus : CraftChangeStatusBtn,
}

export default CraftButtons;